// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mz-1";
export var messageSideRight = "_mz-2";
export var subscribeToBackInStockBubbleContainer = "_mz-0";